export default "__VITE_ASSET__BTlCX_QL__"